import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_13: FaireProductEntity = {
  token: "atc_fs_13",
  type: "product",
  name: "100% Recycled Paper Towels",
  brandName: "Who Gives A Crap",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/93134070c1cae6bdf44030d8fcb2b26d6e58f4e36062adbc5ab035b5a5893a84.webp",
  priceDollars: 16,
  msrpDollars: 32,
  description: "ATC migration seed product",
  tags: ["home", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
